// Yksinkertaisempi versio joka toimii useimmissa teemoissa
(function() {
  'use strict';

  function updateSKU() {
    // Hae valittu variantti-ID
    const variantInput = document.querySelector('input[name="id"]:checked') || 
                        document.querySelector('select[name="id"]') ||
                        document.querySelector('input[name="id"]');
    
    if (!variantInput) return;
    
    const variantId = variantInput.value;
    const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    
    if (!productHandle || !variantId) return;

    // Hae tuotteen JSON-data
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);
        
        if (variant) {
          // Päivitä SKU
          const skuElement = document.querySelector('.product-sku__value');
          const skuContainer = document.querySelector('.product-sku');
          
          if (skuElement) {
            skuElement.textContent = variant.sku || '';
            
            if (skuContainer) {
              if (variant.sku) {
                skuContainer.removeAttribute('hidden');
              } else {
                skuContainer.setAttribute('hidden', '');
              }
            }
          }
          
          // Päivitä barcode jos käytössä
          const barcodeElement = document.querySelector('.product-info__barcode-value');
          const barcodeContainer = document.querySelector('.product-info__barcode');
          
          if (barcodeElement) {
            barcodeElement.textContent = variant.barcode || '';
            
            if (barcodeContainer) {
              if (variant.barcode) {
                barcodeContainer.removeAttribute('hidden');
              } else {
                barcodeContainer.setAttribute('hidden', '');
              }
            }
          }
        }
      })
      .catch(error => console.error('SKU update error:', error));
  }

  // Kuuntele kaikkia mahdollisia variantin vaihdon tapoja
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' || 
        e.target.closest('variant-selects') || 
        e.target.closest('variant-radios') ||
        e.target.classList.contains('product-form__input')) {
      updateSKU();
    }
  });

  // Kuuntele myös click-tapahtumia (radio-napit)
  document.addEventListener('click', function(e) {
    if (e.target.type === 'radio' && e.target.name === 'id') {
      setTimeout(updateSKU, 100);
    }
  });

})();
